import { useState } from 'react';

const PLACEMENT_CLASS = {
  top: 'bottom-full mb-1',
  bottom: 'top-full mt-1',
};

/**
 * Hover and keyboard-focus label for a button that only shows an icon.
 * Visual only: the button keeps its own aria-label, which carries the text.
 */
const IconTooltip = ({ label, placement = 'top', children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <span
      className="relative inline-flex shrink-0"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
      onPointerDown={() => setIsOpen(false)}
      onKeyDown={(event) => {
        if (event.key === 'Escape') setIsOpen(false);
      }}
    >
      {children}
      <span
        aria-hidden="true"
        hidden={!isOpen}
        data-testid="icon-tooltip"
        className={`pointer-events-none absolute left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-800 px-2.5 py-1.5 text-xs font-medium text-white shadow-lg ${PLACEMENT_CLASS[placement]}`}
      >
        {label}
      </span>
    </span>
  );
};

export default IconTooltip;
